/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import { Box } from 'particles'
export default props => <Box is="aside" {...props} {...props.layout}/>





// WEBPACK FOOTER //
// ./src/interface/theme/layout/zones/DashboardMainPanelRight/index.js